const isEmptyValue = (value: unknown) => value === '' || value === null || value === undefined;

/**
 * Returns a shallow copy of the object without empty string, null, or undefined values.
 * Preserves falsy values like 0 and false.
 */
export const getObjectWithoutEmptyValues = (obj: object = {}) =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => !isEmptyValue(value)));
